import { useMemo } from 'react';
import { EntitlementType } from '@/@types/entitlement';
import { useGetProductsStatus } from '@/apiHooks/productsStatus.hook';
import { useGetHasEntitlement } from '@/customHooks/useGetHasEntitlement.hook';
import { LEGACY_BILLCHECK_STATUS } from '@/@types/legacyBillCheck';

export const useBillCheckV3 = () => {
  const { productsStatus, areProductsRefetching } = useGetProductsStatus();
  const isEntitled = useGetHasEntitlement(EntitlementType.UTILITY_BILL_CHECK);

  // In order to not couple the changes on the Backend between the new and the old bill-check flows
  // we have decided to check separately on the FE if a user is eligible to start a new flow.
  // The logic we decided on is the following:
  // IF for the legacy bill-check the property "newFlowAvailable" is true OR IF the property "status" of the last bill-check has a value of "STARTED"
  // AND for the V3 bill-check the property "canStartNewBillCheckFlow" is true
  // THEN the user is allowed to start a new bill-check
  const canStartLegacyBillCheckFlow =
    !!productsStatus?.billcheck?.newFlowAvailable ||
    productsStatus?.billcheck?.billChecks?.[0].status === LEGACY_BILLCHECK_STATUS.STARTED;

  return useMemo(
    () => ({
      canStartNewBillCheck: canStartLegacyBillCheckFlow && !!productsStatus.billcheckV3?.canStartNewBillCheckFlow,
      lastBillCheck: productsStatus?.billcheckV3?.billChecks?.[0],
      billChecks: productsStatus?.billcheckV3?.billChecks,
      isEntitled,
      areProductsRefetching,
    }),
    [productsStatus, isEntitled, areProductsRefetching, canStartLegacyBillCheckFlow],
  );
};
